<template>
  <v-container fluid class="pa-6">
    <router-view />
  </v-container>
</template>

<script>
export default {
  name: "IaColetaEvidenciasLayout",
};
</script>
